// routes/chartRoutes.tsx
import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import BasicChart from '../pages/Chart/BasicChart';
import AdvancedChart from '../pages/Chart/AdvancedChart';
import ProtectedRouteV2 from './ProtectedRouteV2';

const chartRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/chart/basic-chart"
      element={
        <>
          <PageTitle title="Basic Chart | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <BasicChart />
        </>
      }
    />
    <Route
      path="/chart/advanced-chart"
      element={
        <>
          <PageTitle title="Advanced Chart | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <AdvancedChart />
        </>
      }
    />
  </Route>
);

export default chartRoutes;
